import { IBaseDtoType, ICoordinates, ISocialUsernames } from './common.type'
import { IImpactLibraryBaseWithId } from './impacts-library.type'
import { IMedia, IMediaBase, IMediaFile } from './media.type'
import { ERewardActivityStatus, IRewardActivityBaseWithId } from './rewadr-acrivity.type'
import { IUserByIdRawRespDto } from './user.type'

export interface IConsumerScanBase {
  barcode_id: string
  company_name: string
  product_name: string
  product_type: string
  summary: string
  user_tx: string
}

export interface IConsumerScanBaseWithId extends IConsumerScanBase, IBaseDtoType {}

export interface IScanToEarnCreateForm {
  barcode_value: string
  company_name: string
  product_name: string
  summary: string
  media: IMediaFile[]
  impacts: IImpactLibraryBaseWithId[]
  new_impacts: string[]
  coords: ICoordinates
}

export interface IScanToEarnCreateDto {
  barcode_id: string
  company_name: string
  product_name: string
  summary: string
  media: IMediaFile[]
  impacts: IImpactLibraryBaseWithId[]
  new_impacts: string[]
  coords: ICoordinates
}

export interface IScanToEarnCreateDtoWithUploadedMedia {
  barcode_id: string
  company_name: string
  product_name: string
  summary: string
  media: IMediaBase[]
  impacts: IImpactLibraryBaseWithId[]
}

export interface IScanToEarnGetInformationDto {
  barcode_id: string
  mediaFiles: File[]
}
export interface IScanToEarnGetInformationRespDto {
  summary: string
  impacts: IImpactLibraryBaseWithId[]
  new_impacts: string[]
  company_name: string
  product_name: string
  media_validation: boolean
  media_validation_message: string
  tempMediaUrls: string[]
}

export interface IScanToEarnFindImpactsDto {
  tempMediaUrls: string[]
}

export interface IScanToEarnFindImpactsRespDto {
  impacts: IImpactLibraryBaseWithId[]
  new_impacts: string[]
}

export interface IConsumerScanLocationInfo {
  coords: ICoordinates
  ip_address: string
  user_agent: string
  accept_language: string
  referer: string
  country: string
  package_language: string
}

export interface IConsumerScanInfoRespDto {
  id: string
  product_type: string
  summary: string
  user_tx: string
  user_tx_decrypted: string
  media: Pick<IMedia, 'link' | 'link_medium' | 'title' | 'id'>[]
  scanner_info: IConsumerScanLocationInfo
  impactLibraries: IImpactLibraryBaseWithId[]
  not_recognized_impacts: string[]

  not_approved_by: string | null
  not_approved_on: Date | null
  approved_by: string | null
  approved_on: Date | null
}

export interface IConsumerScanRespDto {
  id: string
  created_at: Date
  barcode_id: string
  company_name: string
  product_name: string
  rewardActivity: IRewardActivityBaseWithId
  user: IUserByIdRawRespDto

  productExists: boolean
  accountExists: boolean
}

export interface IConsumerScansRespDto {
  data: IConsumerScanRespDto[]
  count: number
  unknownCount: number
}

export interface IConsumerScanDeclineReason {
  id: string
  name: string
  reason_text: string
}

export interface IConsumerScanUpdateStatusDto {
  id: string
  status: ERewardActivityStatus
  approval_feedbacks?: string[]
  decline_reason?: IConsumerScanDeclineReason
}

export enum EConsumerScanStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  DECLINED = 'declined',
}

export interface IScanToEarnSettingsModal {
  accountExists: boolean
  productExists: boolean

  accountName: string
  productName: string

  consumerScanId: string
}

export interface IScanToEarnSettingsConfirmModal {
  createProduct: boolean
  createAccount: boolean

  accountName?: string
  productName?: string

  consumerScanId: string
  selectedAccountId: string | null
}

export interface IScanToEarnCreateAccountOrProductDto {
  create_product: boolean
  create_account: boolean

  consumer_scan_id: string
  selected_account_id: string | null
}

export interface IScanToEarnExistingAccount {
  id: string
  account_holder: string
  image_small?: string
  website?: string
  socials: ISocialUsernames | null
}

export interface AccountMatchResult {
  accountsByName: IScanToEarnExistingAccount[]
  matchedAccount: IScanToEarnExistingAccount | null // exact country + name match
  bestMatchByNameAccount: IScanToEarnExistingAccount | null // highest (products + impacts) if no exact match
}
